import SectionHeader from "../components/SectionHeader.jsx";
import ProductCard from "../components/ProductCard.jsx";
import CTA from "../components/CTA.jsx";
import { ingredientCategories, industries, targetAudiences, whyFreezeDrying } from "../data/content.js";
import { assetUrl, withBase } from "../utils/sitePaths.js";

const exportPillars = [
  "Sourcing intelligence",
  "Ingredient flexibility",
  "Export-focused execution",
  "Long-term reliability"
];

const proofPoints = [
  "Modern ingredient company",
  "Export-focused from India",
  "Clean-label thinking",
  "Inquiry-led partnerships"
];

export default function Home() {
  return (
    <>
      <section
        className="home-hero"
        style={{ "--home-hero-image": `url(${assetUrl("/images/premium-powders.jpg")})` }}
      >
        <div className="section-inner hero-grid">
          <div className="hero-copy-block">
            <p className="eyebrow">Freeze-dried ingredients from India</p>
            <h1>Built for brands that care what goes into their products.</h1>
            <p>
              Freeze-dried fruits, vegetables, botanicals, tea cuts and functional ingredients sourced
              from India for the next generation of food, wellness and beverage brands.
            </p>
            <div className="button-row">
              <a href={withBase("/products")} className="button button-primary">
                Explore Ingredients
              </a>
              <a href={withBase("/contact")} className="button button-light">
                Request Product Catalog
              </a>
              <a href={withBase("/contact")} className="button button-light">
                Start a Conversation
              </a>
            </div>
          </div>

          <aside className="hero-panel" aria-label="Ingredient sourcing highlights">
            <img src={assetUrl("/images/application-dried-mango.jpg")} alt="Freeze-dried mango slices for food and wellness applications" />
            <div className="hero-panel-body">
              <span>Brand positioning</span>
              <strong>Freeze-dried ingredients for brands thinking ahead.</strong>
              <p>Modern, premium, ingredient-focused and globally aware.</p>
            </div>
          </aside>
        </div>
      </section>

      <section className="proof-strip" aria-label="Credibility focus">
        <div className="section-inner proof-grid">
          {proofPoints.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      <section className="content-band audience-band">
        <div className="section-inner section-split">
          <div>
            <p className="eyebrow">Built for global ingredient buyers</p>
            <h2>Created for the teams evaluating what goes into the product.</h2>
          </div>
          <div className="audience-grid">
            {targetAudiences.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner two-column">
          <SectionHeader
            eyebrow="Brand philosophy"
            title="Not just freeze-dried. Thoughtfully preserved."
            text="We’re exploring freeze-drying not just as a process — but as a smarter way to preserve flavor, functionality and shelf life for modern food brands."
          />
          <p className="large-copy">
            From tropical fruits to tea cuts and wellness ingredients, we’re building around sourcing
            intelligence, clean-label thinking and export-focused execution.
          </p>
        </div>
      </section>

      <section className="content-band product-band">
        <div className="section-inner">
          <SectionHeader
            eyebrow="Product ecosystem"
            title="An ecosystem of ingredients. Not just products."
          />
          <div className="product-grid">
            {ingredientCategories.map((item) => (
              <ProductCard key={item.title} item={item} />
            ))}
          </div>
        </div>
      </section>

      <section className="content-band dark-band">
        <div className="section-inner">
          <SectionHeader
            eyebrow="Why freeze drying"
            title="Preserving more than just shelf life."
          />
          <div className="application-grid">
            {whyFreezeDrying.map((item) => (
              <article key={item.title} className="application-block">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="content-band split-band">
        <div className="section-inner two-column">
          <div>
            <p className="eyebrow">India advantage</p>
            <h2>India gives us an unfair advantage.</h2>
          </div>
          <div className="copy-stack">
            <p>
              From tropical fruits and herbs to botanicals and agricultural diversity, India offers one
              of the world’s strongest ecosystems for freeze-dried ingredient sourcing.
            </p>
            <p>
              ContiGO Freeze Foods is being built around connecting this sourcing strength with modern
              global food applications.
            </p>
          </div>
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner two-column">
          <SectionHeader
            eyebrow="Export positioning"
            title="Made in India. Built for global shelves."
            text="We are focused on building long-term relationships with global importers, ingredient distributors, wellness brands and food businesses seeking reliable freeze-dried ingredient sourcing from India."
          />
          <div className="signal-grid">
            {exportPillars.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="content-band muted-band">
        <div className="section-inner">
          <SectionHeader eyebrow="Industries we serve" title="Where our ingredients fit." />
          <div className="industry-strip">
            {industries.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}
